import React, { useEffect, useRef, useState } from "react";
import { portfolioData } from "../data/portfolioData";

const Counter = ({ value, decimals = 0, prefix = "", suffix = "" }) => {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return;

    const duration = 1200;
    const start = performance.now();

    const update = (time) => {
      const progress = Math.min((time - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(value * eased);
      if (progress < 1) {
        requestAnimationFrame(update);
      }
    };

    requestAnimationFrame(update);
  }, [started, value]);

  return (
    <span ref={ref} className="text-4xl font-bold text-white md:text-5xl">
      {prefix}
      {count.toFixed(decimals)}
      {suffix}
    </span>
  );
};

const Achievements = () => {
  return (
    <section id="achievements" className="py-10 md:py-14 scroll-mt-24">
      <div className="mx-auto max-w-6xl px-4">
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {portfolioData.achievements.map((item) => (
            <article
              key={item.label}
              className="rounded-2xl border border-slate-700/60 bg-slate-900/55 p-6"
            >
              <Counter
                value={item.value}
                decimals={item.decimals}
                prefix={item.prefix}
                suffix={item.suffix}
              />
              <p className="mt-2 text-sm text-slate-300">{item.label}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
